<template>
    <sections>
        <app-subheader title="Dancer" :parent="{title: 'Home', route: '/'}" :dark="true">
            <button-subheader
                v-if="isAdmin && dancer"
                buttonIcon="edit"
                buttonText="Edit"
                :buttonHref="$config.public.admin.dancer + dancer.id_dancer"
                :dark="true"
            ></button-subheader>
        </app-subheader>
        <section-jumbo
            v-if="dancer"
            padding="py-20 sm:py-32 lg:py-32 xl:py-36 2xl:py-48"
            color="bg-zinc-950"
            :image="dancer.dancer_image_url"
            imageOpacity="opacity-30"
            imagePosition="object-[50%_20%]"
            :heading="dancer.dancer_name"
            headingColor="text-white"
            :content="jumboContent"
        ></section-jumbo>
        <section-cards
            v-if="dancer && videos?.length"
            :contentful="true"
            padding="py-10"
            heading="Videos"
            :cards="
                videos.map((video) => {
                    return {
                        route: useContextVideo().route(video),
                        image: video.video_thumb_url,
                        heading: video.video_title_placing,
                        excerpt: video.video_excerpt,
                    };
                })
            "
        ></section-cards>
        <section-text
            v-if="dancer && videos?.length === 0"
            color="bg-zinc-900"
            heading="Coming Soon"
            headingColor="text-zinc-100"
            headingComponent="h2"
            content="<p>Videos are inbound, please check back soon!</p>"
            contentColor="text-zinc-300"
        ></section-text>
        <section-text
            v-if="dancer"
            color="bg-zinc-920"
            heading="Learn West Coast Swing!"
            headingColor="text-zinc-200"
            headingComponent="h2"
            content="<article-learn-swing />"
            contentColor="text-zinc-400"
            buttonText="Search Classes"
            buttonRoute="/classes"
        ></section-text>
        <section-text
            v-if="error"
            heading="404 Not Found"
            headingColor="text-zinc-200"
            content="<p>Apologies, but we can't find that dancer.</p>"
            contentColor="text-zinc-400"
        ></section-text>
        <loading-spinner v-if="dancer === null && !error"></loading-spinner>
    </sections>
</template>

<script setup>
const dancerSlug = useRoute().params.dancerSlug;

const {isAdmin} = storeToRefs(useStoreAuth());

const {dancer, videos, error} = storeToRefs(useStoreDancer());
const {getDancer} = useStoreDancer();

await useLazyAsyncData('getDancer' + dancerSlug, () => getDancer(dancerSlug).then(() => true));

useSeoDancer().buildReactiveHead(dancer, error);

const jumboContent = computed(() => {
    if (!dancer.value) return null;
    let content = '';
    let things = {
        Website: dancer.value.dancer_website,
        TikTok: dancer.value.dancer_tiktok,
        Instagram: dancer.value.dancer_instagram,
        YouTube: dancer.value.dancer_youtube,
    };
    for (const key in things) {
        if (things[key] && !content) {
            content += '<p>';
        } else if (things[key] && content !== '<p>') {
            content += ' | ';
        }
        if (things[key]) content += `<a class="text-sm sm:text-lg" href='${things[key]}' target='_blank'>${key}</a>`;
    }
    if (content) content += '</p>';
    return content;
});
</script>
